/* eslint-disable react/prop-types */
import {useContext} from 'react'

import Context from '@s-ui/react-context'
import Helmet from '@s-ui/react-head'
import AdDisplay from '@adv-mt/mt-ad-display'
import Layout from '@adv-mt/mt-layout-basic'
import ListModels from '@adv-mt/mt-list-models'
import ListTagChips from '@adv-mt/mt-list-tag-chips'
import MotorTagCloud from '@adv-mt/mt-list-tagcloud'
import ListVersions from '@adv-mt/mt-list-versions'
import Breadcrumb from '@adv-mt/mt-navigation-breadcrumb'
import SectionBasic, {sectionBasicMargins} from '@adv-mt/mt-section-basic'
import SectionWrapper from '@adv-mt/mt-shared-section-wrapper'
import TechnicalDetailsPanelLinks from '@adv-mt/mt-technical-details-panel-links'
import TechnicalDetailsPanelSlider from '@adv-mt/mt-technical-details-panel-slider'
import MotorTrackingCriteo from '@adv-mt/mt-tracking-criteo'
import TrackingPageView from '@adv-mt/mt-tracking-page-view'

import LinkFactory from '../../../components/LinkFactory/index.js'
import {getInitialProps} from './getInitialProps.js'

const TechnicalDetailsModel = ({
  breadcrumb,
  bodyTypeName = '',
  doors,
  helmet = {},
  initialPageInfo,
  isBodyTypePage,
  makeId,
  makeName = '',
  makeUrlParam,
  modelUrlParam,
  modelName = '',
  hasNewVehicles,
  pageName,
  router,
  tagclouds
}) => {
  const {i18n} = useContext(Context)

  const make = {id: makeId, name: makeName}

  const {vehicles} = initialPageInfo?.modelInfo || []
  const panelSliderTitle = isBodyTypePage
    ? {
        literal: 'TECHNICAL_DETAILS_BODY_TYPE_TITLE',
        params: {
          makeName,
          modelName,
          bodyTypeName,
          doors
        }
      }
    : {
        literal: 'TECHNICAL_DETAILS_MODEL_TITLE',
        params: {
          makeName,
          modelName
        }
      }

  const linksTitle = i18n.t('TECHNICAL_DETAILS_MODEL_LINKS_TITLE', {
    makeName,
    modelName
  })

  const competitorsTitle = i18n.t('TECHNICAL_DETAILS_MODEL_COMPETITORS_TITLE', {
    makeName,
    modelName
  })

  const numberElements = initialPageInfo?.modelInfo?.vehicles?.length
  const versionsTitle = i18n.t('TECHNICAL_DETAILS_MODEL_VERSIONS_TITLE', {
    numberElements,
    makeName,
    modelName
  })

  const bodyTypesList = initialPageInfo?.modelInfo?.bodyTypes?.map(type => {
    const {bodyType, doors} = type
    const title = i18n.t('TECHNICAL_DETAILS_BODY_TYPE_DOORS_TAG', {
      bodyType,
      doors
    })

    return {...type, title}
  })

  const handleClickVehicle = index => {
    const {url} = vehicles[index]
    router.push(url)
  }

  const hasRelatedVehicles = Boolean(initialPageInfo?.modelInfo?.relatedVehicles?.length)

  const hasBodyTypesList = Boolean(bodyTypesList)

  const hasVehicles = Boolean(vehicles)
  return (
    <Layout.Basic linkFactory={LinkFactory}>
      <SectionBasic margin={sectionBasicMargins.xxl}>
        <TechnicalDetailsPanelSlider title={panelSliderTitle} images={initialPageInfo?.modelInfo?.images} />
        {hasBodyTypesList && <ListTagChips items={bodyTypesList} linkFactory={LinkFactory} />}
      </SectionBasic>
      <SectionWrapper title={versionsTitle}>
        <div className="mt-TechnicalDetailsModel-versionsWrapper">
          {hasVehicles && <ListVersions vehicles={vehicles} onRowClick={handleClickVehicle} hasPrice hasCollapsible />}
        </div>
      </SectionWrapper>
      <SectionWrapper title={linksTitle}>
        <TechnicalDetailsPanelLinks
          makeUrlParam={makeUrlParam}
          makeName={makeName}
          modelUrlParam={modelUrlParam}
          modelName={modelName}
          hasNewVehicles={hasNewVehicles}
        />
      </SectionWrapper>
      {hasRelatedVehicles && (
        <SectionWrapper title={competitorsTitle}>
          <ListModels models={initialPageInfo.modelInfo.relatedVehicles} hasMakeLabel linkFactory={LinkFactory} />
        </SectionWrapper>
      )}
      <SectionWrapper>
        {tagclouds && (
          <MotorTagCloud
            initialTagclouds={tagclouds}
            pageName={pageName}
            makeId={initialPageInfo?.modelInfo?.makeId}
            linkFactory={LinkFactory}
          />
        )}
      </SectionWrapper>
      <Breadcrumb items={breadcrumb} linkFactory={LinkFactory} />
      <Helmet {...helmet} />
      <TrackingPageView
        pageName={pageName}
        make={makeName?.toLowerCase()}
        model={modelName?.toLowerCase()}
        bodyType={bodyTypeName?.toLowerCase()}
      />
      <AdDisplay pageName={pageName} make={make} />
      <MotorTrackingCriteo />
    </Layout.Basic>
  )
}

TechnicalDetailsModel.displayName = 'TechnicalDetailsModel'

TechnicalDetailsModel.getInitialProps = getInitialProps

export default TechnicalDetailsModel
